'use client';
import React from 'react';
import { Link } from '@components/Link';
import cn from './style.module.scss';

interface FahidWhatsAppProps {
  whatsAppLink: string;
}

export default function FahidWhatsAppIcon(props: FahidWhatsAppProps) {
  if (!props.whatsAppLink) {
    return null;
  }

  return (
    <div className={cn.fahidWhatsAppLogo}>
      <Link
        url={props.whatsAppLink}
        target="_blank"
        className={cn.fahidWhatsAppLogo__element}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.564 51.791">
          <path
            d="M-2081,73.78c.649-2.383,1.278-4.685,1.906-6.977.537-1.957,1.076-3.914,1.592-5.872a1.219,1.219,0,0,0-.1-.8,25.643,25.643,0,0,1,8.113-33.689,24.2,24.2,0,0,1,17.574-4.168c10.658,1.572,17.787,7.616,21.245,17.778a25.5,25.5,0,0,1-7.413,26.813,25.472,25.472,0,0,1-13.8,6.3,25.162,25.162,0,0,1-14.938-2.616,1.6,1.6,0,0,0-1.217-.142c-4.147,1.105-8.3,2.191-12.443,3.286-.132.041-.274.05-.517.1Zm14.877-7.808a20.735,20.735,0,0,0,19.44,1.288,21.172,21.172,0,0,0,12.544-23.294,21.353,21.353,0,0,0-19.947-17.574,20.828,20.828,0,0,0-14.451,4.766,20.792,20.792,0,0,0-7.87,15.364,20.721,20.721,0,0,0,3.428,12.848,1.163,1.163,0,0,1,.162,1.045c-.677,2.394-1.314,4.789-2,7.274.146-.035.23-.046.307-.064,2.323-.608,4.655-1.207,6.977-1.836a1.971,1.971,0,0,1,.522-.077A1.766,1.766,0,0,1-2066.123,65.972Zm15.14-6.338c-5.841-1.633-10.282-5.2-13.842-9.989a16.427,16.427,0,0,1-3.053-5.587,7.3,7.3,0,0,1,1.491-6.967,2.849,2.849,0,0,1,2.89-1.217l.01.01c1.176-.3,1.694.4,2.079,1.39.578,1.49,1.207,2.961,1.835,4.421a1.31,1.31,0,0,1-.121,1.42c-.517.689-1.014,1.39-1.562,2.058a1,1,0,0,0-.091,1.278,17.592,17.592,0,0,0,8.823,7.585.987.987,0,0,0,1.288-.314c.638-.8,1.308-1.572,1.916-2.393a.968.968,0,0,1,1.3-.416q2.753,1.293,5.476,2.626a.858.858,0,0,1,.375.639,4.868,4.868,0,0,1-2.21,4.614,7.308,7.308,0,0,1-4.053,1.216A9.467,9.467,0,0,1-2050.983,59.634Z"
            transform="translate(2081 -22)"
          />
        </svg>
      </Link>
    </div>
  );
}
